import { Object3D, SpotLight } from 'three';

let flashlight = null;

export function initHeroFlashlight(scene, player) {
  const light = new SpotLight(0xd9f4ff, 5.5, 22, Math.PI / 7, 0.52, 1.4);
  const target = new Object3D();
  light.name = 'heroFlashlight';
  light.castShadow = false;
  scene.add(light, target);
  light.target = target;
  flashlight = { light, target, player };
  updateHeroFlashlight(0);
  return flashlight;
}

export function updateHeroFlashlight(dt = 0) {
  if (!flashlight?.player) return;
  const { light, target, player } = flashlight;
  light.position.set(player.pos.x, 1.55, player.pos.z);
  target.position.set(
    player.pos.x + player.aim.x * 12,
    0.65,
    player.pos.z + player.aim.z * 12,
  );
  light.intensity = 4.6 + Math.sin((performance.now() / 1000 + dt) * 8) * 0.16;
}
